import { render, staticRenderFns } from "./MemberInvitations.vue?vue&type=template&id=fb674886"
import script from "./MemberInvitations.vue?vue&type=script&lang=js"
export * from "./MemberInvitations.vue?vue&type=script&lang=js"
import style0 from "./MemberInvitations.vue?vue&type=style&index=0&id=fb674886&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports